import { useFlag } from '@unleash/proxy-client-react'
import { FeatureToggleFlags } from '@qureos/types'

/* wrapper component for unleash */
export const useFeatureToggle = (featureId: FeatureToggleFlags) => {
  const isEnabled = useFlag(featureId)
  return isEnabled
}
